import { render, staticRenderFns } from "./course-page.vue?vue&type=template&id=5798fda0"
import script from "./course-page.vue?vue&type=script&lang=js"
export * from "./course-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports